import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    tokens: {},
}

export const authorizationSlice = createSlice({
    name: 'authorizations',
    initialState,
    reducers: {
        createAuthorizations: (state, action) => {
            if (action?.payload) {
                state['tokens'] = {
                    ...state?.['tokens'],
                    ...action.payload,
                }
            }
        },
        updateAuthorizations: (state, action) => {
            if (action?.payload) {
                state['tokens'] = {
                    ...state?.['tokens'],
                    ...action.payload,
                }
            }
        },
        deleteAuthorizations: (state) => {
            state['tokens'] = {}
        },
    },
})

export const selectAuthorizations = (state) => state.authorizations
export const {
    createAuthorizations,
    updateAuthorizations,
    deleteAuthorizations,
} = authorizationSlice.actions
export default authorizationSlice.reducer
